import { pluginChannelInfoMap } from '../config/constants';
var withChannelByName = function withChannelByName(target) {
  if (!target.pluginName) {
    throw new Error('插件名称必填，请补充名称');
  }
  var pluginInfo = pluginChannelInfoMap[target.pluginName];

  // 插件信息，必填
  target.info = pluginInfo;
  return target;
};
export default withChannelByName;